import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import "jspdf-autotable";
import "./AdminPanel.css";
import roomsData from '../data/roomsData';

const AdminPanel = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [reservations, setReservations] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    // --- NUEVOS ESTADOS PARA EL SISTEMA DE CUADRITOS ---
    const [selectedRoomsManual, setSelectedRoomsManual] = useState([]);
    const [selectedRoomsMaintenance, setSelectedRoomsMaintenance] = useState([]);
    const [occupiedRoomsManual, setOccupiedRoomsManual] = useState([]);
    const [occupiedRoomsMaintenance, setOccupiedRoomsMaintenance] = useState([]);

    const getLocalDate = (date) => {
        const d = new Date(date);
        d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    const initialManualData = {
        roomId: roomsData[0]?.id || '',
        clientName: '',
        clientName2: '',
        rutOrPassport: '',
        phone: '',
        nationality: '',
        address: '',
        checkIn: getLocalDate(today),
        checkOut: getLocalDate(tomorrow),
        numberOfGuests: 1,
    };

    const [filterDate, setFilterDate] = useState(getLocalDate(today));
    const [manualData, setManualData] = useState(initialManualData);
    const [maintenanceData, setMaintenanceData] = useState({
        roomId: roomsData[0]?.id || '',
        checkIn: getLocalDate(today),
        checkOut: getLocalDate(tomorrow),

    
    });
    // --- NUEVOS ESTADOS PARA SECCIÓN ELIMINAR ---
    const [selectedRoomsDelete, setSelectedRoomsDelete] = useState([]);
    const [deleteDate, setDeleteDate] = useState(getLocalDate(today)); 
    const [occupiedForDelete, setOccupiedForDelete] = useState([]);

    // --- FUNCIÓN PARA VERIFICAR DISPONIBILIDAD DEL GRID ---
    const checkGridAvailability = async (checkIn, checkOut, type) => {
        try {
            const response = await axios.post('https://three-2cs3.onrender.com/api/reservations/check-availability', {
                checkIn,
                checkOut
            });
            const occupied = response.data.unavailableRooms || [];
            if (type === 'manual') {
                setOccupiedRoomsManual(occupied);
                // Si una habitación seleccionada ahora está ocupada por cambio de fecha, la quitamos
                setSelectedRoomsManual(prev => prev.filter(id => !occupied.includes(id)));
            } else {
                setOccupiedRoomsMaintenance(occupied);
                setSelectedRoomsMaintenance(prev => prev.filter(id => !occupied.includes(id)));
            }
        } catch (error) {
            console.error("Error al verificar disponibilidad del grid:", error);
        }
    };

    // Actualizar grids cuando cambian las fechas
    useEffect(() => {
        if (isLoggedIn) checkGridAvailability(manualData.checkIn, manualData.checkOut, 'manual');
    }, [manualData.checkIn, manualData.checkOut, isLoggedIn]);

    useEffect(() => {
        if (isLoggedIn) checkGridAvailability(maintenanceData.checkIn, maintenanceData.checkOut, 'maintenance');
    }, [maintenanceData.checkIn, maintenanceData.checkOut, isLoggedIn]);

    // Lógica para detectar qué habitaciones tienen reserva en la fecha de eliminación
    useEffect(() => {
        if (isLoggedIn && deleteDate) {
            const roomsWithRes = reservations.filter(res => {
                const checkIn = res.checkIn.split('T')[0];
                const checkOut = res.checkOut.split('T')[0];
                return deleteDate >= checkIn && deleteDate < checkOut;
            }).map(res => res.roomId);

            // Bloqueamos (gris) las que NO tienen reserva para que no se puedan marcar
            const notOccupied = roomsData.map(r => r.id).filter(id => !roomsWithRes.includes(id));
            setOccupiedForDelete(notOccupied);
            
            // Limpia selección si cambia la fecha y la habitación ya no tiene reserva
            setSelectedRoomsDelete(prev => prev.filter(id => roomsWithRes.includes(id)));
        }
    }, [deleteDate, reservations, isLoggedIn]);

    const handleLogin = (e) => {
        e.preventDefault();
        if (username === "admin" && password === "jallalla1478") {
            setIsLoggedIn(true);
        } else {
            alert("Usuario o contraseña incorrectos.");
        }
    };

    const handleLogout = () => {
        setIsLoggedIn(false);
        setUsername('');
        setPassword('');
        setReservations([]);
    };

    const fetchReservations = async () => {
        setLoading(true);
        try {
            const response = await axios.get("https://three-2cs3.onrender.com/api/reservations");
            setReservations(response.data);
        } catch (error) {
            console.error("Error al obtener reservas:", error);
        } finally {
            setLoading(false);
        }
    };

    const deleteReservation = async (id) => {
        if (!window.confirm("¿Estás seguro de eliminar esta reserva?")) return;
        try {
            await axios.delete(`https://three-2cs3.onrender.com/api/reservations/${id}`);
            fetchReservations();
        } catch (error) {
            console.error("Error al eliminar reserva:", error);
        }
    };
    const handleDeleteFromGrid = async () => {
        if (selectedRoomsDelete.length === 0) return;
        if (!window.confirm(`¿Seguro que quieres eliminar las reservas de las habitaciones: ${selectedRoomsDelete.join(', ')}?`)) return;

        setLoading(true);
        try {
            for (const roomId of selectedRoomsDelete) {
                const resToDelete = reservations.find(res => {
                    const checkIn = res.checkIn.split('T')[0];
                    const checkOut = res.checkOut.split('T')[0];
                    return res.roomId === roomId && deleteDate >= checkIn && deleteDate < checkOut;
                });
                if (resToDelete) {
                    await axios.delete(`https://three-2cs3.onrender.com/api/reservations/${resToDelete._id}`);
                }
            }
            alert("Eliminación completada.");
            setSelectedRoomsDelete([]);
            fetchReservations();
        } catch (error) {
            console.error(error);
            alert("Error al eliminar.");
        } finally {
            setLoading(false);
        }
    };

    const downloadPDF = () => {
        const doc = new jsPDF({ orientation: 'landscape' });
        const title = `Registro de Huéspedes - ${formatDateForDisplay(filterDate)}`;
        doc.text(title, 14, 16);
        const sortedReservations = [...filteredReservations].sort((a, b) => a.roomId - b.roomId);
        const head = [['ID Hab.', 'Nombre', 'RUT/Pasaporte', 'País', 'Teléfono', 'Check-In', 'Check-Out', 'Noches', 'Total ($)', 'Medio de Pago', 'Estado de Pago']];
        const body = sortedReservations.map(res => {
            const room = roomsData.find(r => r.id === res.roomId);
            let clientNames = res.clientName;
            if (room && (room.type.toLowerCase().includes('matrimonial') || room.type.toLowerCase().includes('doble')) && res.clientName2) {
                clientNames = `${res.clientName}\n${res.clientName2}`;
            }
            const estadoDePago = res.paymentStatus === 'pagado' ? 'Pagado' : 'Pendiente';
            const medioDePago = (res.paymentMethod && res.paymentMethod !== 'En Hostal') ? res.paymentMethod : '';
            return [
                res.roomId, clientNames, res.rutOrPassport, res.nationality, res.phone,
                formatDateForDisplay(res.checkIn), formatDateForDisplay(res.checkOut),
                res.nights, res.totalCost?.toLocaleString('es-CL') || '0', 
                medioDePago, estadoDePago
            ];
        });
        doc.autoTable({
            startY: 22, head: head, body: body, theme: 'grid',
            headStyles: { fillColor: [41, 128, 186] },
            didDrawCell: (data) => {
                if (data.column.index === 1 && data.row.index >= 0) {
                    const res = sortedReservations[data.row.index];
                    if (res) {
                        const room = roomsData.find(r => r.id === res.roomId);
                        if (room && (room.type.toLowerCase().includes('matrimonial') || room.type.toLowerCase().includes('doble')) && res.clientName2) {
                            const y = data.cell.y + data.cell.height / 2;
                            doc.line(data.cell.x, y, data.cell.x + data.cell.width, y);
                        }
                    }
                }
            },
        });
        doc.save(`registro_huespedes_${filterDate}.pdf`);
    };

    const handleManualFormChange = (e) => {
        const { name, value } = e.target;
        setManualData(prevData => {
            const newData = { ...prevData, [name]: value };
            if (name === 'checkIn') {
                const checkInDate = new Date(value);
                const checkOutDate = new Date(newData.checkOut);
                if (checkOutDate <= checkInDate) {
                    const nextDay = new Date(checkInDate);
                    nextDay.setDate(nextDay.getDate() + 1);
                    newData.checkOut = getLocalDate(nextDay);
                }
            }
            if(name === 'roomId'){
                const room = roomsData.find(r => r.id === parseInt(value));
                if(room && room.type.toLowerCase().includes('individual')){
                    newData.numberOfGuests = 1;
                }
            }
            if (name === 'numberOfGuests' && value === '1') {
                newData.clientName2 = '';
            }
            return newData;
        });
    };

    const handleMaintenanceFormChange = (e) => {
        const { name, value } = e.target;
        setMaintenanceData(prevData => {
            const newData = { ...prevData, [name]: value };
            if (name === 'checkIn') {
                const checkInDate = new Date(value);
                const checkOutDate = new Date(newData.checkOut);
                if (checkOutDate <= checkInDate) {
                    const nextDay = new Date(checkInDate);
                    nextDay.setDate(nextDay.getDate() + 1);
                    newData.checkOut = getLocalDate(nextDay);
                }
            }
            return newData;
        });
    };

    // --- LÓGICA DE SUBMIT MANUAL ACTUALIZADA PARA SELECCIÓN MÚLTIPLE ---
    const handleManualSubmit = async (e) => {
        e.preventDefault();
        
        // Determinar qué habitaciones procesar
        const roomsToProcess = selectedRoomsManual.length > 0 
            ? selectedRoomsManual 
            : [parseInt(manualData.roomId)];

        if (manualData.checkIn >= manualData.checkOut) {
            alert('Error: La fecha de ingreso debe ser anterior a la fecha de salida.');
            return;
        }
        if (manualData.numberOfGuests == 2 && !manualData.clientName2) {
            alert('Error: Por favor, ingrese el nombre del segundo huésped.');
            return;
        }

        setLoading(true);
        try {
            // Verificar disponibilidad para todas las seleccionadas
            const availabilityResponse = await axios.post('https://three-2cs3.onrender.com/api/reservations/check-availability', {
                checkIn: manualData.checkIn,
                checkOut: manualData.checkOut
            });
            const occupied = availabilityResponse.data.unavailableRooms || [];
            
            const conflictRooms = roomsToProcess.filter(id => occupied.includes(id));
            if (conflictRooms.length > 0) {
                alert(`Error: Las habitaciones [${conflictRooms.join(', ')}] están ocupadas.`);
                setLoading(false);
                return;
            }

            // Crear las reservas
            const promises = roomsToProcess.map(id => {
                return axios.post('https://three-2cs3.onrender.com/api/reservations', { 
                    ...manualData, 
                    roomId: id,
                    numberOfGuests: parseInt(manualData.numberOfGuests),
                    clientName2: manualData.numberOfGuests == 2 ? manualData.clientName2 : undefined,
                    paymentMethod: 'En Hostal',
                    paymentStatus: 'pendiente',
                });
            });

            await Promise.all(promises);
            alert(`¡Reserva manual creada con éxito para ${roomsToProcess.length} habitación(es)!`);
            fetchReservations();
            setManualData(initialManualData); 
            setSelectedRoomsManual([]); // Limpiar selección de cuadritos
        } catch (error) {
            alert('Error al crear la reserva.');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    // --- LÓGICA DE SUBMIT MANTENIMIENTO ACTUALIZADA PARA SELECCIÓN MÚLTIPLE ---
    const handleMaintenanceSubmit = async (e) => {
        e.preventDefault();
        const roomsToProcess = selectedRoomsMaintenance.length > 0 
            ? selectedRoomsMaintenance 
            : [parseInt(maintenanceData.roomId)];

        if (maintenanceData.checkIn >= maintenanceData.checkOut) {
            alert('Error: La fecha de inicio debe ser anterior a la fecha de fin.');
            return;
        }
        
        setLoading(true);
        try {
            const availabilityResponse = await axios.post('https://three-2cs3.onrender.com/api/reservations/check-availability', {
                checkIn: maintenanceData.checkIn,
                checkOut: maintenanceData.checkOut
            });
            const occupied = availabilityResponse.data.unavailableRooms || [];
            const conflictRooms = roomsToProcess.filter(id => occupied.includes(id));
            
            if (conflictRooms.length > 0) {
                alert(`Error: Habitaciones [${conflictRooms.join(', ')}] ocupadas. No se puede bloquear.`);
                setLoading(false);
                return;
            }

            const promises = roomsToProcess.map(id => {
                return axios.post('https://three-2cs3.onrender.com/api/reservations', {
                    ...maintenanceData,
                    roomId: id,
                    clientName: 'MANTENIMIENTO',
                    rutOrPassport: 'N/A', phone: 'N/A', nationality: 'N/A', address: 'N/A', numberOfGuests: 0,
                    totalCost: 0, 
                });
            });

            await Promise.all(promises);
            alert(`¡${roomsToProcess.length} habitaciones bloqueadas por mantenimiento!`);
            fetchReservations();
            setSelectedRoomsMaintenance([]);
        } catch (error) {
            alert('Error al bloquear fechas.');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleBlockAllRooms = async () => {
        if (!window.confirm("¿Bloquear todas las habitaciones disponibles? (Las reservas de clientes actuales no se tocarán)")) return;
        
        if (maintenanceData.checkIn >= maintenanceData.checkOut) {
            alert('Error: La fecha de inicio debe ser anterior a la fecha de fin.');
            return;
        }

        setLoading(true);
        try {
            const availabilityResponse = await axios.post('https://three-2cs3.onrender.com/api/reservations/check-availability', {
                checkIn: maintenanceData.checkIn,
                checkOut: maintenanceData.checkOut
            });

            const occupiedRoomIds = availabilityResponse.data.unavailableRooms || [];
            const roomsToBlock = roomsData.filter(room => !occupiedRoomIds.includes(room.id));

            if (roomsToBlock.length === 0) {
                alert('No hay habitaciones disponibles para bloquear en estas fechas.');
                setLoading(false);
                return;
            }

            const blockPromises = roomsToBlock.map(room => {
                return axios.post('https://three-2cs3.onrender.com/api/reservations', {
                    roomId: parseInt(room.id),
                    checkIn: maintenanceData.checkIn,
                    checkOut: maintenanceData.checkOut,
                    clientName: 'MANTENIMIENTO',
                    rutOrPassport: 'N/A', phone: 'N/A', nationality: 'N/A', address: 'N/A', 
                    numberOfGuests: 0,
                    totalCost: 0, 
                });
            });

            await Promise.all(blockPromises);
            alert(`Éxito: Se bloquearon ${roomsToBlock.length} habitaciones. Se respetaron ${occupiedRoomIds.length} reservas existentes.`);
            fetchReservations();
        } catch (error) {
            alert('Hubo un error al procesar el bloqueo masivo.');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const formatDateForDisplay = (dateString) => {
        if (!dateString) return "N/A";
        const datePart = dateString.split('T')[0];
        const [year, month, day] = datePart.split('-');
        return `${day}/${month}/${year}`;
    };

    useEffect(() => {
        if (isLoggedIn) { fetchReservations(); }
    }, [isLoggedIn]);

    const filteredReservations = reservations.filter(res => {
        const checkIn = res.checkIn.split('T')[0];
        const checkOut = res.checkOut.split('T')[0];
        return filterDate >= checkIn && filterDate < checkOut;
    });

    const selectedRoomForManualEntry = roomsData.find(r => r.id === parseInt(manualData.roomId));

    // --- COMPONENTE AUXILIAR PARA EL GRID DE HABITACIONES ---
    const RoomGrid = ({ type, selected, setSelected, occupied }) => {
        const toggleRoom = (id) => {
            if (occupied.includes(id)) return;
            setSelected(prev => 
                prev.includes(id) ? prev.filter(roomId => roomId !== id) : [...prev, id]
            );
        };

        return (
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(9, 1fr)',
                gap: '8px',
                margin: '15px auto',
                padding: '10px',
                backgroundColor: '#f0f0f0',
                borderRadius: '15px',
                maxWidth: '500px'
            }}>
                {roomsData.sort((a,b) => a.id - b.id).map(room => (
                    <div
                        key={room.id}
                        onClick={() => toggleRoom(room.id)}
                        style={{
                            width: '35px',
                            height: '35px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '8px',
                            cursor: occupied.includes(room.id) ? 'not-allowed' : 'pointer',
                            backgroundColor: occupied.includes(room.id) ? '#6c757d' : selected.includes(room.id) ? '#28a745' : '#fff',
                            color: (occupied.includes(room.id) || selected.includes(room.id)) ? '#fff' : '#000',
                            border: '1px solid #ccc',
                            fontWeight: 'bold',
                            fontSize: '14px',
                            transition: '0.2s'
                        }}
                        title={occupied.includes(room.id) ? "Ocupada" : room.type}
                    >
                        {room.id}
                    </div>
                ))}
            </div>
        );
    };

    return (
        <div style={{ textAlign: "center", padding: "20px" }}>
            {!isLoggedIn ? (
                <form onSubmit={handleLogin}>
                    <h2>Iniciar Sesión</h2>
                    <input type="text" placeholder="Usuario" value={username} onChange={(e) => setUsername(e.target.value)} style={{ padding: "10px", marginBottom: "10px", width: "200px" }} required />
                    <br />
                    <input type="password" placeholder="Contraseña" value={password} onChange={(e) => setPassword(e.target.value)} style={{ padding: "10px", marginBottom: "10px", width: "200px" }} required />
                    <br />
                    <button type="submit" style={{ padding: "10px 20px", cursor: "pointer" }}>Ingresar</button>
                </form>
            ) : (
                <div>
                    <h2>Panel de Administración</h2>
                    <div className="admin-actions">
                        <button onClick={handleLogout} className="back-btn">Cerrar Sesión</button>
                        <button onClick={() => navigate("/")} className="back-btn">Volver a Inicio</button>
                        <button onClick={downloadPDF} className="back-btn">Descargar PDF de la vista actual</button>
                    </div>

                    <div className="admin-section">
                        <h3>Crear Reserva Manualmente</h3>

                    {/* BOTÓN REFRESCAR DISPONIBILIDAD MANUAL */}
<div style={{ display: 'flex', justifyContent: 'flex-end', maxWidth: '500px', margin: '0 auto 10px' }}>
    <button 
        type="button"
        onClick={async () => {
            await fetchReservations(); // Refresca la tabla
            checkGridAvailability(manualData.checkIn, manualData.checkOut, 'manual'); // Fuerza el recálculo del grid
        }}
        disabled={loading}
        style={{ 
            background: 'none', border: 'none', cursor: 'pointer', 
            fontSize: '14px', color: '#007bff', display: 'flex', 
            alignItems: 'center', gap: '5px', fontWeight: 'bold' 
        }}
    >
        {loading ? 'Cargando...' : '↻ Actualizar disponibilidad'}
    </button>
</div>
                        
                        {/* GRID DE HABITACIONES MANUAL */}
                        <RoomGrid 
                            type="manual" 
                            selected={selectedRoomsManual} 
                            setSelected={setSelectedRoomsManual} 
                            occupied={occupiedRoomsManual} 
                        />

                        <form onSubmit={handleManualSubmit} className="admin-form">
                            <div style={{ display: 'flex', gap: '10px', alignItems: 'center', width: '100%' }}>
                                <select 
                                    name="roomId" 
                                    value={manualData.roomId} 
                                    onChange={handleManualFormChange}
                                    disabled={selectedRoomsManual.length > 0}
                                    style={{ opacity: selectedRoomsManual.length > 0 ? 0.5 : 1 }}
                                >
                                    {roomsData.map(room => <option key={room.id} value={room.id}>{`${room.type} (ID: ${room.id})`}</option>)}
                                </select>
                                
                                {selectedRoomsManual.length > 0 && (
                                    <button 
                                        type="button" 
                                        onClick={() => setSelectedRoomsManual([])} 
                                        className="back-btn" 
                                        style={{ margin: 0, padding: '5px 15px', backgroundColor: '#007bff' }}
                                    >
                                        Atrás
                                    </button>
                                )}
                            </div>

                            {selectedRoomForManualEntry && !selectedRoomForManualEntry.type.toLowerCase().includes('individual') && (
                                <select name="numberOfGuests" value={manualData.numberOfGuests} onChange={handleManualFormChange}>
                                    <option value={1}>1 Huésped</option>
                                    <option value={2}>2 Huéspedes</option>
                                </select>
                            )}
                            <input name="clientName" type="text" placeholder="Nombre Cliente 1" value={manualData.clientName} onChange={handleManualFormChange} required />
                            {manualData.numberOfGuests == 2 && selectedRoomForManualEntry && !selectedRoomForManualEntry.type.toLowerCase().includes('individual') && (
                                <input 
                                    name="clientName2" 
                                    type="text" 
                                    placeholder="Nombre Cliente 2" 
                                    value={manualData.clientName2} 
                                    onChange={handleManualFormChange}
                                    required
                                />
                            )}
                            <input name="rutOrPassport" type="text" placeholder="RUT o Pasaporte" value={manualData.rutOrPassport} onChange={handleManualFormChange} required />
                            <input name="phone" type="text" placeholder="Teléfono" value={manualData.phone} onChange={handleManualFormChange} />
                            <input name="nationality" type="text" placeholder="Nacionalidad" value={manualData.nationality} onChange={handleManualFormChange} />
                            <input name="address" type="text" placeholder="Dirección" value={manualData.address} onChange={handleManualFormChange} />
                            <label>Check-in: 
                                <input name="checkIn" type="date" value={manualData.checkIn} onChange={handleManualFormChange} min={getLocalDate(new Date())} />
                            </label>
                            <label>Check-out: 
                                <input name="checkOut" type="date" value={manualData.checkOut} onChange={handleManualFormChange} min={getLocalDate(new Date(new Date(manualData.checkIn).getTime() + 86400000))} />
                            </label>
                            <button type="submit" disabled={loading}>
                                {loading ? 'Cargando...' : selectedRoomsManual.length > 1 ? `Crear ${selectedRoomsManual.length} Reservas` : 'Crear Reserva'}
                            </button>
                        </form>
                    </div>

                    <div className="admin-section">
                        <h3>Bloquear Fechas por Mantenimiento</h3>
{/* BOTÓN REFRESCAR DISPONIBILIDAD MANTENIMIENTO */}
<div style={{ display: 'flex', justifyContent: 'flex-end', maxWidth: '500px', margin: '0 auto 10px' }}>
    <button 
        type="button"
        onClick={async () => {
            await fetchReservations(); // Refresca la tabla
            checkGridAvailability(maintenanceData.checkIn, maintenanceData.checkOut, 'maintenance'); // Fuerza el recálculo del grid
        }}
        disabled={loading}
        style={{ 
            background: 'none', border: 'none', cursor: 'pointer', 
            fontSize: '14px', color: '#007bff', display: 'flex', 
            alignItems: 'center', gap: '5px', fontWeight: 'bold' 
        }}
    >
        {loading ? 'Cargando...' : '↻ Actualizar disponibilidad'}
    </button>
</div>
                        {/* GRID DE HABITACIONES MANTENIMIENTO */}
                        <RoomGrid 
                            type="maintenance" 
                            selected={selectedRoomsMaintenance} 
                            setSelected={setSelectedRoomsMaintenance} 
                            occupied={occupiedRoomsMaintenance} 
                        />

                        <form onSubmit={handleMaintenanceSubmit} className="admin-form">
                            <div style={{ display: 'flex', gap: '10px', alignItems: 'center', width: '100%' }}>
                                <select 
                                    name="roomId" 
                                    value={maintenanceData.roomId} 
                                    onChange={handleMaintenanceFormChange}
                                    disabled={selectedRoomsMaintenance.length > 0}
                                    style={{ opacity: selectedRoomsMaintenance.length > 0 ? 0.5 : 1 }}
                                >
                                    {roomsData.map(room => <option key={room.id} value={room.id}>{`${room.type} (ID: ${room.id})`}</option>)}
                                </select>
                                
                                {selectedRoomsMaintenance.length > 0 && (
                                    <button 
                                        type="button" 
                                        onClick={() => setSelectedRoomsMaintenance([])} 
                                        className="back-btn" 
                                        style={{ margin: 0, padding: '5px 15px', backgroundColor: '#007bff' }}
                                    >
                                        Atrás
                                    </button>
                                )}
                            </div>

                            <label>Desde: 
                                <input name="checkIn" type="date" value={maintenanceData.checkIn} onChange={handleMaintenanceFormChange} min={getLocalDate(new Date())} />
                            </label>
                            <label>Hasta: 
                                <input name="checkOut" type="date" value={maintenanceData.checkOut} onChange={handleMaintenanceFormChange} min={getLocalDate(new Date(new Date(maintenanceData.checkIn).getTime() + 86400000))} />
                            </label>
                            
                            <div style={{ display: 'flex', gap: '10px', marginTop: '10px', justifyContent: 'flex-start' }}>
                                <button type="submit" style={{ padding: '8px 15px', fontSize: '14px', borderRadius: '10px',}}>
                                    {selectedRoomsMaintenance.length > 1 ? `Bloquear ${selectedRoomsMaintenance.length} Hab.` : 'Bloquear Habitación'}
                                </button>
                                
                                <button 
                                    type="button" 
                                    onClick={handleBlockAllRooms} 
                                    disabled={loading}
                                    style={{ 
                                        backgroundColor: '#dc3545', 
                                        color: 'white',             
                                        border: 'none',             
                                        padding: '8px 15px',        
                                        fontSize: '14px',           
                                        cursor: 'pointer',          
                                        borderRadius: '10px',        
                                        fontWeight: 'bold'          
                                    }}
                                >
                                    {loading ? 'Consultando...' : 'Bloquear TODAS las disponibles'}
                                </button>
                            </div>
                        </form>
                    </div>
{/* --- SECCIÓN ELIMINAR RESERVAS ACTUALIZADA --- */}
                    <div className="admin-section" style={{ borderTop: '2px solid #dc3545', marginTop: '20px', paddingTop: '20px' }}>
                        {/* Título dinámico que muestra la fecha elegida */}
                        <h3 style={{ color: '#dc3545' }}>
                            Eliminar reservas ({formatDateForDisplay(deleteDate)})
                        </h3>
                        
                        <div style={{ marginBottom: '15px' }}>
                            <input 
                                type="date" 
                                value={deleteDate} 
                                onChange={(e) => {
                                    setDeleteDate(e.target.value);
                                    setSelectedRoomsDelete([]); 
                                }} 
                            />
                        </div>

                        <RoomGrid 
                            type="delete" 
                            selected={selectedRoomsDelete} 
                            setSelected={setSelectedRoomsDelete} 
                            occupied={occupiedForDelete} 
                        />

                        <div style={{ marginTop: '15px' }}>
                            <button 
                                onClick={handleDeleteFromGrid}
                                disabled={selectedRoomsDelete.length === 0 || loading}
                                style={{ 
                                    backgroundColor: '#dc3545', 
                                    color: 'white', 
                                    padding: '10px 20px', 
                                    borderRadius: '10px',
                                    border: 'none',
                                    cursor: selectedRoomsDelete.length === 0 ? 'not-allowed' : 'pointer',
                                    fontWeight: 'bold'
                                }}
                            >
                                {loading ? 'Procesando...' : selectedRoomsDelete.length > 0 
                                    ? `Eliminar ${selectedRoomsDelete.length} Habitación(es)` 
                                    : 'Seleccionar habitaciones'}
                            </button>
                            
                            {selectedRoomsDelete.length > 0 && (
                                <button 
                                    onClick={() => setSelectedRoomsDelete([])}
                                    style={{ marginLeft: '10px', backgroundColor: '#7448f6ff', color: 'white', border: 'none', padding: '10px', borderRadius: '10px' }}
                                >
                                    Atrás
                                </button>
                            )}
                        </div>
                    </div>
                    <div className="admin-section">
                        <h3>Filtrar Reservas por Fecha</h3>
                        <div className="filter-container">
                            <label>Mostrar reservas activas el día:</label>
                            <input type="date" value={filterDate} onChange={(e) => setFilterDate(e.target.value)} />
                        </div>
                    </div>
                    
                    {loading ? (
                        <p>Procesando...</p>
                    ) : (
                        <div style={{ overflowX: 'auto', maxWidth: '100%' }}>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Hab.</th>
                                        <th>Cliente</th>
                                        <th>Teléfono</th>
                                        <th>RUT/Pasaporte</th>
                                        <th>Nacionalidad</th>
                                        <th>Dirección</th>
                                        <th>Tipo de Habitación</th>
                                        <th>Check-In</th>
                                        <th>Check-Out</th>
                                        <th>Noches</th>
                                        <th>Precio Total</th>
                                        <th>Estado de Pago</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {[...filteredReservations]
                                        .sort((a, b) => a.roomId - b.roomId)
                                        .map((res) => (
                                        <tr key={res._id} className={res.clientName === 'MANTENIMIENTO' ? 'maintenance-row' : ''}>
                                            <td>
                                                <div style={{
                                                    backgroundColor: res.clientName === 'MANTENIMIENTO' ? '#6c757d' : '#007bff',
                                                    color: 'white',
                                                    width: '30px',
                                                    height: '30px',
                                                    borderRadius: '50%',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontWeight: 'bold',
                                                    margin: '0 auto',
                                                    fontSize: '14px'
                                                }}>
                                                    {res.roomId}
                                                </div>
                                            </td>
                                            <td>{res.clientName2 ? `${res.clientName} / ${res.clientName2}`: res.clientName}</td>
                                            <td>{res.phone}</td>
                                            <td>{res.rutOrPassport}</td>
                                            <td>{res.nationality}</td>
                                            <td>{res.address}</td>
                                            <td style={{ textAlign: 'left', fontSize: '12px' }}>
                                                {roomsData.find(r => r.id === res.roomId)?.type || 'Habitación'}
                                            </td>
                                            <td>{formatDateForDisplay(res.checkIn)}</td>
                                            <td>{formatDateForDisplay(res.checkOut)}</td>
                                            <td>{res.nights}</td>
                                            <td>{res.totalCost?.toLocaleString()} CLP</td>
                                            <td>
                                                <span style={{ color: res.paymentStatus === 'pagado' ? 'green' : 'orange', fontWeight: 'bold' }}>
                                                    {res.paymentStatus === 'pagado' ? 'Pagado' : 'Pendiente'}
                                                </span>
                                            </td>
                                            <td><button className="delete-btn" onClick={() => deleteReservation(res._id)}>Eliminar</button></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default AdminPanel;